import styles from "./TariffCalculatorSection.module.scss";
import arrow_right from "../../../../assets/images/pages/home/tariff-calculator/ArrowRight.svg";
import tariff from "../../../../assets/images/pages/home/tariff-calculator/Tariff.svg";
import weight from "../../../../assets/images/pages/home/tariff-calculator/Weight.svg";
import i from "../../../../assets/images/pages/home/tariff-calculator/i.svg";
import MainButton from "../../../shared/button/MainButton";
import { useEffect, useState } from "react";
import GlobalModalComponent from "../../../shared/globalModal/GlobalModalComponent";
import { CountriesService } from "../../../../services/countries.service";
import {
  CountriesDataType,
  PaymentDataType,
} from "../../../../interface/site.interface";
import { CalculatorService } from "../../../../services/calculator.service";
import SelectComponent from "../../../shared/select/SelectComponent";
import { useSite } from "../../../../context/TranslationContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
const TariffCalculatorSection = () => {
  const [infoModal, setInfoModal] = useState<boolean>(false);
  const [messageModal, setMesssageModal] = useState<boolean>(false);
  const [countries, setCountries] = useState<CountriesDataType[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const language = useSelector((state: RootState) => state.language.language);
  const { data } = useSelector((state: RootState) => state.translationData);
  const [formData, setFormData] = useState({
    country: null as number | null,
    type: null as number | null,
    unit: "kg",
    weight: "",
    width: "",
    height: "",
    length: "",
  });
  const [responseMessage, setResponseMessage] = useState<string>("");
  const [calculaterDEliveryType, setCalculatorDEliveryDataType] = useState<
    PaymentDataType[]
  >([]);
  useEffect(() => {
    CountriesService.getAllCountries()
      .then((res) => {
        const data = res?.data?.original;
        setCountries(data);
      })
      .catch((err) => {
        // console.error("Error fetching tariffs:", err);
      });
    CalculatorService.getCalculatorDeliveryType()
      .then((res) => {
        const data = res?.data?.original;
        setCalculatorDEliveryDataType(data);
      })
      .catch((err) => {
        // console.error("Error fetching tariffs:", err);
      });
  }, [language]);

  const [errors, setErrors] = useState({
    country: "",
    type: "",
    weight: "",
    width: "",
    height: "",
    length: "",
  });
  const [endPice, setEndPrice] = useState([]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    setErrors({
      country: "",
      type: "",
      weight: "",
      width: "",
      height: "",
      length: "",
    });

    CalculatorService.calculateData(formData)
      .then((res) => {
        const data = res?.data;
        if (res.status === 200 && data?.original?.case === "success") {
          setResponseMessage("");
          setMesssageModal(true);
          setEndPrice(data?.original?.amount);
        } else if (res?.status !== 200) {
          const content = res.response.data.content;
          const newErrors: any = {};
          if (content) {
            for (const key in content) {
              if (content[key]?.length > 0) {
                newErrors[key] = content[key].join(", ");
              }
            }
          }
          setErrors(newErrors);
          if (res.response.data.original.content) {
            setResponseMessage(res.response.data.original.content);
          } else {
          }
        } else {
          setResponseMessage(data?.error_occurred);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleCountryChange = async (val: number) => {
    setFormData({
      ...formData,
      country: Number(val),
      type: null,
    });

    const response = await CalculatorService.getCalculatorCountry(val);
    if (response.status === 200) {
      setCalculatorDEliveryDataType(response.data?.original || []);
    }
  };

  return (
    <div id={styles.tariff_calculator}>
      <div className="container">
        <div className={styles.tariff_calculator}>
          <div className={styles.about_calculator}>
            <h1 className={styles.title}>{data?.tariff_calculator}</h1>
            <button className={styles.important_button}>
              {data?.important}
            </button>
            <p className={styles.important_text}>{data?.danger_notice}</p>
            <button
              className={styles.more_info}
              onClick={() => setInfoModal(true)}
            >
              <p>{data?.learn_more}</p> <img src={arrow_right} alt="arrow" />
            </button>
          </div>
          <div className={styles.calculator}>
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.selects}>
                <SelectComponent
                  name="tarif"
                  options={countries.map((country) => ({
                    label: country.title,
                    value: country.id,
                  }))}
                  value={formData.country ?? undefined}
                  onChange={(val: any) => handleCountryChange(val)}
                  placeholder={data?.country}
                  icon={tariff}
                  className={"home_calc_select"}
                  error={errors.country}
                />
                <SelectComponent
                  name="tarif"
                  options={calculaterDEliveryType.map((type) => ({
                    label: type.title,
                    value: type.id,
                  }))}
                  value={formData.type ?? undefined}
                  onChange={(val) =>
                    setFormData({
                      ...formData,
                      type: Number(val),
                    })
                  }
                  placeholder={data?.type_of_delivery}
                  // icon={tarifIcon}
                  className={"home_calc_select"}
                  error={errors.type}
                  disabled={!formData.country} // Ölkə seçilməyibsə disabled olsun
                />
              </div>
              <div className={styles.inputs}>
                <div className={styles.input}>
                  <div className={styles.errorInput}>
                    <input
                      type="text"
                      name="weight"
                      placeholder={data?.weight}
                      value={formData.weight}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(",", ".");
                        const valid = /^[0-9]*\.?[0-9]*$/.test(value);
                        if (value === "" || valid) {
                          setFormData({
                            ...formData,
                            weight: value,
                          });
                        }
                      }}
                    />
                    {errors.weight && (
                      <p className={styles.errorWeight}>{errors.weight}</p>
                    )}{" "}
                  </div>

                  <input
                    type="text"
                    name="height"
                    id="height"
                    placeholder={data?.height}
                    value={formData.height}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(",", ".");
                      const valid = /^[0-9]*\.?[0-9]*$/.test(value);
                      if (value === "" || valid) {
                        setFormData({
                          ...formData,
                          height: value,
                        });
                      }
                    }}
                  />
                </div>
                <div className={styles.input}>
                  <input
                    type="text"
                    name="width"
                    id="width"
                    placeholder={data?.width}
                    value={formData.width}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(",", ".");
                      const valid = /^[0-9]*\.?[0-9]*$/.test(value);
                      if (value === "" || valid) {
                        setFormData({
                          ...formData,
                          width: value,
                        });
                      }
                    }}
                  />

                  <input
                    type="text"
                    name="length"
                    id="length"
                    placeholder={data?.length}
                    value={formData.length}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(",", ".");
                      const valid = /^[0-9]*\.?[0-9]*$/.test(value);
                      if (value === "" || valid) {
                        setFormData({
                          ...formData,
                          length: value,
                        });
                      }
                    }}
                  />
                </div>
              </div>
              {responseMessage ? (
                <p className={styles.error}>{responseMessage}</p>
              ) : (
                <div className={styles.Endamount}>
                  {endPice && endPice.length !== 0 ? (
                    <p>
                      {data?.total_amount}: {endPice}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              )}

              <MainButton
                className={styles.calc_btn}
                text={data?.calculate}
                type="submit"
                disabled={isSubmitting}
              />
            </form>
          </div>
        </div>
      </div>

      {infoModal && (
        <GlobalModalComponent
          isOpen={infoModal}
          onClose={() => setInfoModal(false)}
        >
          <div className={styles.modalContainer}>
            <div className={styles.modal_head}>
              <div className={styles.important}>
                <img src={i} alt="i" />
              </div>
              <h1 className={styles.attention}>{data?.attention}</h1>
            </div>
            <div className={styles.information_text}>
              <div className={styles.text_wrapper}>
                <h1 className={styles.warning}>
                 Vacib Qeyd: Bağlamanın hər hansı bir tərəfinin (en, uzunluq və ya hündürlük) ölçüsü müəyyən həddi keçərsə, 
                 daşınma haqqı fiziki çəki ilə həcm çəkisi arasında hansı daha böyükdürsə, 
                 onun üzərindən hesablanır.<br/>
                 Həcm çəkisinin Beynəlxalq Hava Nəqliyyatı Assosasiyası ( İATA ) qaydalarına uyğun olaraq hesablanma formulu aşağıdakı kimidir :
                </h1>
                <ul className={styles.rules_detail}>
                  <li className={styles.rule_list}>
                   ( En x Uzunluq x Hündürlük) / 8000 = Həcm çəkisi (kq)
                  </li>
                  <li className={styles.rule_list}>
                    Məsələn: 120x20x60/ 6000 = 24 kq
                    24 kq x müvafiq ölkə tarifi = Ümumi daşınma haqqı
                  </li>
                  <li className={styles.rule_list}>
                    Qeyd. Yalnız Çin istiqaməti üzrə: Əgər bağlamanın hər hansı bir tərəfi 60 sm-dən böyükdürsə, həcm çəkisi hesablanır və 8000-ə bölünür.
                  </li>
                  {/* <li className={styles.rule_list}>
                    Digər bütün ölkələr (ABŞ, Türkiyə, Almaniya, İngiltərə, İspaniya):
                    Yalnız bağlamanın hər hansı bir tərəfi 100 sm-dən böyük olduqda həcm çəkisi nəzərə alınır.
                  </li>
                  <li className={styles.rule_list}>
                    Çatdırılma günləri məhsulun Turkiyə anbarına daxil olub və
                    Smart Customsda bəyan edilən gündən sayılır
                  </li> */}
                </ul>
                <div className={styles.additional_info}>
                  Digər bütün ölkələr (ABŞ, Türkiyə, Almaniya, İngiltərə, İspaniya):
                  Yalnız bağlamanın hər hansı bir tərəfi 100 sm-dən böyük olduqda həcm çəkisi nəzərə alınır.
                </div>
              </div>
              <div className={styles.back_button}>
                <MainButton
                  text="Geri dön"
                  onClick={() => setInfoModal(false)}
                />
              </div>
            </div>
          </div>
        </GlobalModalComponent>
      )}
    </div>
  );
};

export default TariffCalculatorSection;
